import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';
import Time from '@cube3/cubicle/src/core/utility/Time';
import DatePicker from '@cube3/forms/src/fields/DatePicker';
import moment from 'moment';
import React, { useRef } from 'react';

export interface Props {
  value: Date;
  onChange(moment): void;
  error?: boolean;
}

export const ExpirationDatePicker = (props: Props) => {
  const { value, onChange, error } = props;
  const minDate = useRef(moment().add(1, 'day')).current;
  const hasExpired = new Date(value) < new Date();

  return (
    <DatePicker
      value={value}
      onChange={onChange}
      minDate={minDate}
      yearOnly={false}
      initialFocusedDate={value}
      showClearButton={false}
      warning={
        !error &&
        props.value && (
          <Typography
            variant="sm"
            colorVariant="03"
            color={hasExpired ? 'warning' : 'default'}
          >
            {`This link ${hasExpired ? 'expired' : 'will expire'}`}{' '}
            <Time
              date={value}
              fullForm={false}
              toolTip={true}
              placement="bottom"
              relativeTime={true}
            />
          </Typography>
        )
      }
    />
  );
};
